import React, { useState, useEffect } from 'react';
import GetIcon from '../../../../utils/Icon';
import { useGetcustomerMutation, useGetCustomerDetailsMutation } from "../../../../store/api/customer_api";
import VersionHistory from '../../../../utils/VersionHistory';
import Input from '../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import CollapsibleSection from '../../../../Core/CollapsibleSection/CollapsibleSection';

function Tab1({ formdata, setTab1Data, setTab1CustomerData, orderNo, termandcondition, fieldErrors, activityboll, pTerms, price, currency, taxandchanges, project, cost_center }) {
  console.log(orderNo, "orderNo_came");

  const [showActivity, setShowActivity] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [getCustomer, { data: getitem_list_data }] = useGetcustomerMutation();
  const [selectedCustomer, setSelectedCustomer] = useState('');
  const [getCustomerDetails] = useGetCustomerDetailsMutation();


  useEffect(() => {
    // Call once on page load with empty search
    getCustomer({ search_input: '' });
  }, []);

  useEffect(() => {
    // Skip if empty — already called on page load
    if (searchTerm) {
      const body = { search_input: searchTerm };
      getCustomer(body);
    }
  }, [searchTerm]);

  useEffect(() => {
    const fetchDetails = async () => {
      if (selectedCustomer) {
        try {
          const response = await getCustomerDetails({ customer_name: selectedCustomer });
          if (response?.data) {
            setTab1CustomerData(prev => ({
              ...prev,
              customerDetails: response.data
            }));
          }
        } catch (error) {
          console.error("Failed to fetch customer details:", error);
        }
      }
    };
    fetchDetails();
  }, [selectedCustomer]);

  const customerOptions = getitem_list_data?.result?.customers?.map(customer => ({
    name: customer.name
  })) || [];

  // const handleChange = (field, value) => {
  //   const newFields = { ...fields, [field]: value };
  //   setFields(newFields);
  //   setTab1Data(newFields);
  // };




  return (

    <div
      className="row sidebarbox m-0"
      style={{
        padding: "8px",
        borderRadius: "5px",
        maxHeight: "72vh",
        minHeight: "72vh",
        overflowY: "scroll",

      }}
    >
      <div style={{ maxHeight: "72vh", }}>
          <div className="d-flex gap-2 mb-2" style={{ width: "100%" }}>
          <div className="col">
            <Input
              id="Sales Invoice Id"
              label="Sales Invoice Id"
              value={formdata.sales_invoice_id }
              readOnly              
              style={{ height: "30px" }}
              className={fieldErrors.orderNo ? 'error-border' : ''}
            />
          </div>
          <div className="col">
            <Input
              id="date"
              label="Order Date"
              type="date"
              value={formdata.payment_due_date}
              readOnly              
              style={{ height: "30px" }}
              className={fieldErrors.date ? 'error-border' : ''}
            />
          </div>
        </div>

        <div className="w-100 mb-3">
          <SelectSearch
            list={customerOptions}
            label="Select Customer"
            getOptionLabel={(item) => item.name}
            getOptionValue={(item) => item.name}
            value={formdata.customer}
            // onChange={(value) => {
            //   setSelectedCustomer(value);
            //   handleChange('customer', value);
            // }}
            disabled={true}
            onInputChange={setSearchTerm}
            className={fieldErrors.customer ? 'error-border' : ''}
          />
        </div>


        <div className="col mb-3">
          <Input
            id="Mobile No"
            label="Mobile No"
            value={formdata.mobile_no}
            style={{ height: "30px" }}
            readOnly
            className={fieldErrors.orderNo ? 'error-border' : ''}
          />
        </div>

        <div className="col mb-3">
          <Input
            id="Delivery Address"
            label="Delivery Address"
            value={formdata.delivery_address}
            style={{ height: "30px" }}
            readOnly
            className={fieldErrors.orderNo ? 'error-border' : ''}
          />
        </div>
        <div className="col mb-3">
          <Input
            id="due_date"
            label="Payment Due Date"
            value={formdata.due_date}
            style={{ height: "30px" }}
            readOnly
            className={fieldErrors.orderNo ? 'error-border' : ''}
          />
        </div>

        <CollapsibleSection title="Accounting Dimensions">
          <div className="col-lg-12 mt-3 mb-3" >
             <Input
                label="Cost Center"
                readOnly
                value={cost_center.value}
                style={{ height: '30px' }}
              />
          </div>
          <div className="col-lg-12 mt-3 mb-3" >
            <Input
                label="Project"
                readOnly
                value={project.value}
                style={{ height: '30px' }}
              />
          </div>
        </CollapsibleSection>
        <CollapsibleSection title="Payment Terms">
          <div className="col-lg-12 mt-3 mb-3" >
            <Input
                label="Payment Terms Template"
                readOnly
                value={pTerms.value}
                style={{ height: '30px' }}
              />
          </div>

        </CollapsibleSection>

        <CollapsibleSection title="Currency and Price List">
          <div className="col-lg-12 mt-3 mb-3" >
            <Input
                label="Currency"
                readOnly
                value={currency.value}
                style={{ height: '30px' }}
              />
          </div>

          <div className="col-lg-12 mt-3 mb-3" >
            <Input
                label="Price List"
                readOnly
                value={price.value}
                style={{ height: '30px' }}
              />
          </div>
        </CollapsibleSection>
        <CollapsibleSection title="Taxes and Charges">
          <div className="col-lg-12 mt-3 mb-3" >
            <Input
                label="Taxes and Charges"
                readOnly
                value={taxandchanges.value}
                style={{ height: '30px' }}
              />
          </div>
        </CollapsibleSection>
        <CollapsibleSection title="Terms & Conditions">
          <div className="col-lg-12 mt-1 mb-3" >
              <Input
                label="Terms and Conditions"
                readOnly
                value={termandcondition.termsandcondition}
                style={{ height: '30px' }}
              />
          </div>
        </CollapsibleSection>


        <div className="col-12">
          <div className="py-2 d-flex justify-content-between align-items-center" onClick={() => setShowActivity(!showActivity)}>
            <p className="firstcolor m-0">
              Activity
            </p>
            <GetIcon
              iconName={showActivity ? "MdKeyboardArrowUp" : "MdKeyboardArrowDown"}
              size={22}
            />
          </div>

          {showActivity && (
            <VersionHistory doctype="Sales Order" docname={orderNo} activityboll={activityboll} />
          )}
        </div>
      </div>
    </div>
  );
}

export default Tab1;